import React, { useState, useEffect, useRef } from 'react'
import { useParams, useNavigate, Link } from "react-router-dom"
import './Year.scss'
import { jwtDecode } from "jwt-decode"
import { Oval } from 'react-loader-spinner'
import { 
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend,
    BarElement,
    CategoryScale,
    LinearScale,
    TimeScale
} from "chart.js";
import { Doughnut, Bar, getElementAtEvent } from 'react-chartjs-2'
import 'chartjs-adapter-date-fns';
import {es} from 'date-fns/locale';
import IllustrationAccess from "../../assets/img/access.png"
import Indicadores from "../../assets/img/indicadores-3.png"
import ModalProyecto from '../../components/Modales/ModalProyecto';

import { usePlanes } from '../../context/PlanesContext'

export const ganttContext = React.createContext()

// Marca el día actual
const todayLine = {
    id: 'todayLine',
    afterDatasetsDraw(chart, args, pluginOptions) {
        // const { ctx, data, chartArea: {top, bottom, left, right}, scales: { x, y } } = chart;
        const { ctx, chartArea: {top, bottom}, scales: { x } } = chart;
        ctx.save();
        ctx.beginPath();
        ctx.lineWidth = 2;
        ctx.strokeStyle = '#6c757d';
        ctx.moveTo(x.getPixelForValue(new Date()), top);
        ctx.lineTo(x.getPixelForValue(new Date()), bottom);
        ctx.stroke();
    }
}

ChartJS.register(
    ArcElement, 
    Tooltip, 
    Legend, 
    BarElement, 
    CategoryScale, 
    LinearScale, 
    TimeScale,
)

function Gantt() {

    const { empresa, fetchEmpresa, fetchEmpresaSinConsultora, area, fetchArea } = usePlanes()

    // const { idConsult, id, idArea, year } = useParams()
    const { idConsult, id, idArea } = useParams()

    const navigate = useNavigate();

    // state
    const [proyectos, setProyectos] = useState([])
    const [error, setError] = useState(null)
    const [loading, setLoading] = useState(true)

    const [tareasRealiz, setTareasRealiz] = useState(null)
    const [tareasNorealiz, setTareasNorealiz] = useState(null)

    const [modalProyecto, setModalProyecto] = useState(false)

    const [yearSelected, setYearSelected] = useState(new Date().getFullYear())

    const [isFullscreen, setIsFullscreen] = useState(false)
    const containerRef = useRef(null)

    const auth = localStorage.getItem("token")
    const jwtParse = jwtDecode(auth)
    const USER = jwtParse.apirest.objeto

    useEffect(()=>{
        const firstFetch = () => {
            fetchProyectos(yearSelected)
            .then(res => {
                if(res.error !== 0){
                    setLoading(false)
                    setError(res.errorDetalle)
                } else {
                    setLoading(false)
                    setProyectos(res.objeto)
                }
            })
        }

        const firstMetrica = () => {
            fetchMetrica(yearSelected)
            .then(res => {
                if(res.error !== 0){
                    console.error(res.errorDetalle)
                } else {
                    let sum = 0;
                    let tareasRealizadas = 0;
                    let tareasNorealizadas = 0;
                    const arr = res.objeto;
                    arr.forEach(e => {
                        sum += e.tareas_totales
                        tareasRealizadas += e.tareas_realizadas
                    })
                    setTareasRealiz(tareasRealizadas)
                    tareasNorealizadas = sum - tareasRealizadas;
                    setTareasNorealiz(tareasNorealizadas)
                }
            })
            .catch(error => {
                console.error("Error: Conexión con backend.")
            })
        }

        firstFetch()
        firstMetrica()
        if (USER.puesto < 3) {
            if(parseInt(idConsult) === 0){
                fetchEmpresaSinConsultora(USER, id)
            } else {
                fetchEmpresa(USER, idConsult, id)
            }
        }
        fetchArea(USER, id, idArea)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    // Fullscreen
    const enterFullscreen = () => {
        if (containerRef.current) {
            if (containerRef.current.requestFullscreen) {
                containerRef.current.requestFullscreen();
            } else if (containerRef.current.mozRequestFullScreen) { // Firefox
                containerRef.current.mozRequestFullScreen();
            } else if (containerRef.current.webkitRequestFullscreen) { // Chrome, Safari and Opera
                containerRef.current.webkitRequestFullscreen();
            } else if (containerRef.current.msRequestFullscreen) { // IE/Edge
                containerRef.current.msRequestFullscreen();
            }
            setIsFullscreen(true);
        }
    };

    const exitFullscreen = () => {
        if (document.exitFullscreen) {
            document.exitFullscreen();
        } else if (document.mozCancelFullScreen) { // Firefox
            document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) { // Chrome, Safari and Opera
            document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) { // IE/Edge
            document.msExitFullscreen();
        }
        setIsFullscreen(false);
    };

    const handleFullscreenToggle = () => {
        if (isFullscreen) {
            exitFullscreen();
        } else {
            enterFullscreen();
        }
    };
    // Fin fullscreen

    // RETROCEDER UN AÑO
    const handleYearBefore = async () => {
        setYearSelected((prevState) => {
            const newYear = prevState - 1

            fetchProyectos(newYear)
            .then(res => {
                if(res.error !== 0){
                    setError(res.errorDetalle)
                } else {
                    setProyectos(res.objeto)
                }
            })

            fetchMetrica(newYear)
            .then(res => {
                if(res.error !== 0){
                    console.error(res.errorDetalle)
                } else {
                    let sum = 0;
                    let tareasRealizadas = 0;
                    let tareasNorealizadas = 0;
                    const arr = res.objeto;
                    arr.forEach(e => {
                        sum += e.tareas_totales
                        tareasRealizadas += e.tareas_realizadas
                    })
                    // setTotalTareas(sum)
                    setTareasRealiz(tareasRealizadas)
                    tareasNorealizadas = sum - tareasRealizadas;
                    setTareasNorealiz(tareasNorealizadas)
                }
            })
            .catch(error => {
                console.error("Error: Conexión con backend.")
            })

            return newYear
        })
    }

    // ADELANTAR UN AÑO
    const handleYearAfter = () => {
        let newYear;
        setYearSelected((prevState) => {
            if(prevState === new Date().getFullYear() + 1){
                newYear = prevState
            } else {
                newYear = prevState + 1
            }

            fetchProyectos(newYear)
            .then(res => {
                if(res.error !== 0){
                    setError(res.errorDetalle)
                } else {
                    setProyectos(res.objeto)
                }
            })

            fetchMetrica(newYear)
            .then(res => {
                if(res.error !== 0){
                    console.error(res.errorDetalle)
                } else {
                    let sum = 0;
                    let tareasRealizadas = 0;
                    let tareasNorealizadas = 0;
                    const arr = res.objeto;
                    arr.forEach(e => {
                        sum += e.tareas_totales
                        tareasRealizadas += e.tareas_realizadas
                    })
                    setTareasRealiz(tareasRealizadas)
                    tareasNorealizadas = sum - tareasRealizadas;
                    setTareasNorealiz(tareasNorealizadas)
                }
            })
            .catch(error => {
                console.error("Error: Conexión con backend.")
            })

            return newYear
        })
    }

    // Actualizar el listado de proyectos
    const fetchProyectos = async (y) => {
        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/apis/planAccion/viewProyect`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    idArea: parseInt(idArea),
                    user: USER,
                    fecha: parseInt(y)
                })
            });
            const data = await res.json()
            return data
        } catch (error) {
            setError("Error: Conexión con backend.")
        }
    }

    // Obtener datos para las métricas
    const fetchMetrica = async (y) => {
        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/apis/planAccion/metricasProyectos`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    id_area: parseInt(idArea),
                    user: USER,
                    fecha: parseInt(y)
                })
            });
            const data = await res.json();
            return data
        } catch (error) {
            console.error("Error: Conexión con backend.")
        }
    }

    // FECHAS INICIALES DEL PROYECTO
    const nombresRepetidos = {}
    const arrGantt = []

    proyectos.forEach((e) => {
        let nombre = e.nombre

        if (nombresRepetidos[nombre]) {
            nombre += ` (${nombresRepetidos[nombre]})`
            nombresRepetidos[e.nombre] += 1
        } else {
            nombresRepetidos[nombre] = 1
        }

        arrGantt.push(
            {
                y: nombre,
                x: [e.fecha_inicio, e.fecha_final],
                idProyecto: e.id_proyecto,
                // percentage: '50%'
            }
        )
    })

    // FECHAS REALES BASADAS EN SUS TAREAS FINALIZADAS
    const nombresRepetidosReal = {}
    const arrGanttReal = []

    proyectos.forEach((e) => {
        let nombre = e.nombre

        if (nombresRepetidosReal[nombre]) {
            nombre += ` (${nombresRepetidosReal[nombre]})`
            nombresRepetidosReal[e.nombre] += 1
        } else {
            nombresRepetidosReal[nombre] = 1
        }

        if(e.fecha_final_tareas !== null){
            arrGanttReal.push(
                {
                    y: nombre,
                    x: [e.fecha_inicio_tareas, e.fecha_final_tareas]
                }
            )
        } else {
            arrGanttReal.push({})
        }
    })

    // Doughnut Chart (MÉTRICAS)
    const data = {
        labels: ['Realizadas', 'No realizadas'],
        datasets: [{
            label: '',
            data: [tareasRealiz, tareasNorealiz],
            backgroundColor: ['#0d6efd', '#9ec5fe'],
            borderColor: '#fff',
            hoverOffset: 4,
            tooltip: {
                callbacks: {
                    label: function(context) {
                        let label = context.label;
                        let value = context.formattedValue;
        
                        if (!label)
                            label = 'Unknown'
        
                        let sum = 0;
                        let dataArr = context.chart.data.datasets[0].data;
                        // eslint-disable-next-line array-callback-return
                        dataArr.map(data => {
                            sum += Number(data);
                        });
        
                        let percentage = (value * 100 / sum).toFixed(2) + '%';
                        return percentage.slice(0,4) + '%';
                    }
                }
            }
        }]
    }

    const options = {
        plugins: {
            legend: {
                display: false
            },
        },
        cutout: 40
    }

    // Bar Chart
    const dataBar = {
        datasets : [
          {
            label: 'Fechas establecidas',
            data: arrGantt,
            backgroundColor: '#0d6efd',
            borderWidth: 0,
            borderSkipped: false,
            borderRadius: 12,
            barThickness: 18
          },
          {
            label: 'Fechas reales',
            data: arrGanttReal,

            backgroundColor: '#6ea8fe',
            borderWidth: 0,
            borderSkipped: false,
            borderRadius: 12,
            barThickness: 18
          }
        ]
    }

    // const numBars = dataBar.datasets[0].data.length;
    // const containerHeight = 40 * numBars;

    const optionsBar = {
        plugins: {
            legend: {
                display: true,
                labels: {
                    font: {
                        family: 'sans-serif'
                    }
                }
            },
            tooltip: {
                callbacks : {
                    label: (ctx) => {
                        const startDate = new Date(ctx.raw.x[0]).toLocaleDateString('es-ES', {timeZone: 'UTC', day: '2-digit', month: 'short'})
                        const endDate = new Date(ctx.raw.x[1]).toLocaleDateString('es-ES', {timeZone: 'UTC', day: '2-digit', month: 'short'})
                        return `${startDate} - ${endDate}`
                    }
                }
            }
        },
        layout: {},
        indexAxis: 'y',
        onHover: (event, chartElement) => {
            event.native.target.style.cursor = chartElement[0] ? 'pointer' : 'default'
        },
        scales: {
            x: {
                position: 'top',
                type: 'time',
                time: {
                    unit: 'month'
                },
                ticks: {
                    callback: (value, index, ticks) => {
                        const date = new Date(value);
                        return new Intl.DateTimeFormat('es-ES', {
                            // year: 'numeric',
                            month: 'short',
                        }).format(date)
                    },
                    font: {
                        family: 'sans-serif'
                    }
                },
                min: `${parseInt(yearSelected)}-01-01`,
                max: `${parseInt(yearSelected)}-12-31`
                // min: `2024-01-01`,
                // max: `2025-12-31`
            },
            y: {
                ticks: {
                    font: {
                        family: 'sans-serif'
                    }
                }
            }
        },
        adapters: {
            date: {
                locale: es
            }
        },
        // responsive: true,
        // maintainAspectRatio: false,
    }

    const ruta = USER.puesto >= 3 ? "" : `/consultora/${idConsult}/empresa/${id}`

    const chartRef = useRef()
    const onClick = (e) => {
        if(getElementAtEvent(chartRef.current, e).length > 0){
            const dataPoint = getElementAtEvent(chartRef.current, e)[0].index
            const data = {
                title: dataBar.datasets[0].data[dataPoint].y,
                year: yearSelected,
                idPro: dataBar.datasets[0].data[dataPoint].idProyecto
            }
            if(USER.puesto <= 3){
                navigate(`/planes-de-accion${ruta}/area/${idArea}/${yearSelected}/proyectos/${data.idPro}`, {state: data})
            } else {
                navigate(`/planes-de-accion${ruta}/${yearSelected}/proyectos/${data.idPro}`, {state: data})
            }
        }
    }

    const handleFormProyecto = (e) => {
        e.preventDefault()
        setModalProyecto(true)
    }

    return (
        <>
            <ganttContext.Provider value={{ idArea, proyectos, setProyectos, fetchProyectos, yearSelected }}>
                <ModalProyecto show={modalProyecto} onHide={()=>setModalProyecto(false)}/>
            </ganttContext.Provider>
            <div className='proyectos__year section'>
                <div className='section__header d-flex flex-row align-items-end mb-4'>
                    <i className='bi bi-bar-chart-steps me-2'></i>
                    <h4 className='m-0'><Link className='breadcrumb__generico' to={'/planes-de-accion'}>Planes de acción</Link> {USER.puesto < 3 && <><i className="bi bi-chevron-right"></i> <Link className='breadcrumb__generico' to={`/planes-de-accion${ruta}`}>{`${empresa}`}</Link></>} {USER.puesto <= 5 && <><i className="bi bi-chevron-right"></i> {area}</>}</h4>
                </div>
                {loading ? (
                    <div className='loading__year d-flex flex-column align-items-center justify-content-center'>
                        <Oval
                            visible={true}
                            height="80"
                            width="80"
                            color="#0d6efd"
                            ariaLabel="oval-loading"
                            wrapperStyle={{}}
                            wrapperClass=""
                        />
                        <p className='fw-medium'>Loading...</p>
                    </div>
                ) : (
                    <>
                        {error ? (
                            <div className='proyectos__year--error d-flex flex-column align-items-center justify-content-center'>
                                <img className='mb-4' src={IllustrationAccess} alt="" />
                                <h2>Oops!</h2>
                                <p>{error}</p>
                            </div>
                        ) : (
                            <div className='proyectos__year__main scroll--y'>
                                {/* SECCIÓN GANTT */}
                                <div className='proyectos__year__main__content'>
                                    <div className='proyectos__year__main__content__introduccion d-flex flex-column align-items-center flex-md-row justify-content-md-between rounded-3 mb-4'>
                                        <div className='proyectos__year__main__content__introduccion__textos'>
                                            <h2 className='text-white'>Mantente al tanto de tus planes de acción</h2>
                                            <p className='text-white mb-0'>Aquí encontrarás el listado de planes de acción por año.</p>
                                        </div>
                                    </div>
                                    <div className='d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between'>
                                        <h3 className='m-0 text-blue-500 mb-2 mb-md-0'>Gantt de proyectos</h3>
                                        <button onClick={handleFormProyecto} className='px-4 btn btn-primary text-white rounded-pill shadow-sm fw-medium'>Agregar proyecto</button>
                                    </div>
                                    <div ref={containerRef} className='proyectos__year__main__content__grafica mb-4'>
                                        <div className='d-flex flex-row align-items-center justify-content-between mb-3'>
                                            <button onClick={handleYearBefore} className='px-3 btn btn-sm btn-outline-primary rounded-pill fw-medium'><i className="bi bi-chevron-left"></i> prev</button>
                                            <h3 className='m-0 text-blue-500'>{yearSelected}</h3>
                                            <button onClick={handleYearAfter} className='px-3 btn btn-sm btn-outline-primary rounded-pill fw-medium'>next <i className="bi bi-chevron-right"></i></button>
                                        </div>
                                        <Bar 
                                            data={dataBar}
                                            options={optionsBar}
                                            plugins={[todayLine]}
                                            onClick={onClick}
                                            ref={chartRef}
                                        />
                                        <button onClick={handleFullscreenToggle} className='btn__expandir btn p-0'>
                                            {isFullscreen ? <i className="bi bi-arrows-angle-contract"></i> : <i className="bi bi-arrows-angle-expand"></i>}
                                        </button>
                                    </div>
                                </div>
                                {/* SECCIÓN GRÁFICAS */}
                                {proyectos.length === 0 ? (
                                    <div className='proyectos__year__main__aside--empty d-flex flex-column rounded-3'>
                                        <div className='proyectos__year__main__aside--empty__textos mb-3'>
                                            <h2 className='text-white'>Mide y analiza tus proyectos</h2>
                                            <p className='text-white m-0'>Aquí encontrarás métricas con información relevante respecto a tus tareas.</p>
                                        </div>
                                        <img src={Indicadores} alt='Indicadores' />
                                    </div>
                                ) : (
                                    <div className='proyectos__year__main__aside'>
                                        <div className='proyectos__year__main__aside__graficas'>
                                            <div className='doughnut__grafica d-flex flex-column shadow-sm rounded-3 border border-light-subtle'>
                                                <div className='doughnut__grafica__info d-flex flex-row align-items-center'>
                                                    <div className='doughnut__grafica__info__textos'>
                                                        <h4 className='mb-2'>Total de tareas</h4>
                                                        <p className='mb-1 fw-medium'>Tareas realizadas: <span>{tareasRealiz}</span></p>
                                                        <p className='mb-0'>Tareas no realizadas: <span>{tareasNorealiz}</span></p>
                                                    </div>
                                                    <div className='doughnut__grafica__info__chart'>
                                                        <Doughnut 
                                                            data={data}
                                                            options={options}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                
                            </div>
                        )}
                    </>
                    
                )}
            </div>
        </>
    )
}

export default Gantt